module.exports = __webpack_public_path__ + "static/koteks_video-1c42561a39a892c1c476fa00c7799ef6.mp4";